'use client'

import { CommonImage } from '@/components/common';
import xss from 'xss';
import parse from 'html-react-parser';
import { safeHtmlListParserOptions } from '@/utils/safeHtmlParserOptions';


const CategoryBannerCard = ({ data }: any) => {
  const sanitizedDescription = xss(data?.bannerDescription ?? '');

  return (
    <section className='relative aspect-[18/10] sm:aspect-[16/6] md:aspect-[29/10] lg:aspect-[24/5] overflow-hidden'>
      {data.bannerUrl ? (
        <CommonImage
          className='absolute inset-0 h-full w-full object-cover object-center'
          src={data?.bannerUrl}
          alt={data?.bannerTitle}
          width={1920}
          height={1080}
        />
      ) : (
        <div className='absolute inset-0 h-full w-full bg-zinc-800' />
      )}
      <div className='absolute inset-0 flex h-full w-full flex-col items-center justify-center gap-2 bg-black/70 px-6 text-center'>
        <h1 className='text-2xl font-extrabold text-white sm:text-4xl md:text-5xl'>
          {data.bannerTitle}
        </h1>
        <div
//          dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
          className='line-clamp-3 max-w-2xl text-sm font-semibold text-white sm:text-base sm:font-medium'
        >
          {parse(sanitizedDescription, safeHtmlListParserOptions)}
          </div>
      </div>
    </section>
  );
};

export default CategoryBannerCard;
